import { DirectionProvider, Drawer, DrawerProps } from "@mantine/core";
import { useEffect, useState } from "react";

interface Props extends DrawerProps {
  close: () => void;
  custom?: string;
}

function CustomDrawer({ children, custom, close, opened, ...props }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const key = custom || "drawer";
  useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash === `#${key}`) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
        close();
      }
    };

    handleHashChange();

    window.addEventListener("hashchange", handleHashChange);
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [close]);

  useEffect(() => {
    if (opened) {
      window.location.hash = `#${key}`;
    }
    setIsOpen(opened);
  }, [opened]);

  const handleClose = () => {
    window.history.back();
    setIsOpen(false);
    close();
  };

  return (
    <DirectionProvider initialDirection="ltr">
      <Drawer {...props} radius="md" opened={isOpen} onClose={handleClose}>
        {children}
      </Drawer>
    </DirectionProvider>

  );
}
export default CustomDrawer;
